export default __webpack_public_path__ + "static/surgical_boom_b.c5e28e2c6599ac583ea248b419803219.svg";